import HTTP from "../http";
import paramsHelper from "../helpers/params";

import Jsona from "jsona";
const dataFormatter = new Jsona();

export default {
  async getByProfessional(payload) {
    let { professionalID, page } = payload;

    let filters = [
      {
        name: "professional",
        value: professionalID
      }
    ];
    let pagination = { number: page, size: 10 };
    let paramsData = { filters, pagination };

    let params = paramsHelper.buildParams(paramsData);

    try {
      let res = await HTTP.normal.get(`/feedbacks${params}`);
      return dataFormatter.deserialize(res.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar feedbacks do profissional";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/feedbacks.js